/* eslint-disable linebreak-style */

export const StyledAboutCards = {
  minWidth: 250,
  maxWidth: 343,
  width: '100%',
  p: 1,
  m: 0,
  backgroundColor: '#ffffffd1',

  '@media (min-width: 668px)': {
    maxWidth: 600
  },

  '@media (min-width: 1025px)': {
  }
};

export const StyledAboutUsCards = {
  minWidth: 250,
  maxWidth: 400,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  m: 0.5,
  backgroundColor: '#ffffffd1',

  '@media (min-width: 668px)': {
    maxWidth: 300
  },

  '@media (min-width: 1025px)': {
  }
}